// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { Color } from "../../Graphics";
export class IndicatorValueEntry {
    constructor(name, value = 0, color = Color.Blue) {
        this.Visible = true;
        this.Name = name;
        this.Value = value;
        this.Color = color;
    }
}
